import { formatDate } from 'i18n/format';
import { t as translate } from 'i18n';
/** Localized copy and small helpers of the knowledge page. */
import { assistantErrorCode } from 'api/assistant';

export const KIND_ORDER = ['rule', 'glossary', 'metric', 'caveat', 'query'];

export const KIND_LABELS = () => ({
  rule: translate('assistant.diagnosticResultsRule'),
  glossary: translate('assistant.diagnosticResultsTerm'),
  metric: translate('assistant.diagnosticResultsMetric'),
  caveat: translate('assistant.diagnosticResultsCaveat'),
  query: translate('assistant.knowledgeCopyQuestionAndQuery'),
});

export const KIND_HINTS = () => ({
  rule: translate('assistant.knowledgeCopyAppliedToEveryQuestionWhatToExclude'),
  glossary: translate('assistant.knowledgeCopyDefinitionOfATermUsedInThe'),
  metric: translate('assistant.knowledgeCopyMetricFormulaWhichFieldsToUseAnd'),
  caveat: translate('assistant.knowledgeCopyDataLimitationWhatIsMissingOrUnreliable'),
  query: translate('assistant.knowledgeCopyAQuestionAndAReadyToUse'),
});

export const STATUS_LABELS = () => ({
  draft: translate('assistant.knowledgeCopyDraft'),
  indexing: translate('assistant.knowledgeCopyIndexing'),
  ready: translate('assistant.knowledgeCopyReady'),
  failed: translate('assistant.diagnosticResultsError'),
});

export const STATUS_COLORS = {
  draft: 'default',
  indexing: 'default',
  ready: 'success',
  failed: 'error',
};

export const ACCEPTED_FILES = '.txt,.md,.markdown,.rst,.csv,.json,.yml,.yaml';
export const MAX_FILE_MB = 2;

const TRANSLIT = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i', й: 'y',
  к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f',
  х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

/** A latin kebab-case slug of a Russian or English title (up to 80 chars). */
export function slugify(title) {
  const latin = Array.from(String(title || '').toLowerCase())
    .map((ch) => (ch in TRANSLIT ? TRANSLIT[ch] : ch))
    .join('');
  return latin
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '');
}

const ERRORS = () => ({
  not_admin: translate('assistant.knowledgeCopyOnlyOwnersAndAdministratorsCanChangeProject'),
  too_large: translate('assistant.knowledgeCopyTheFileExceedsMB', { value1: MAX_FILE_MB }),
  unsupported_type: translate('assistant.knowledgeCopySupportedTextFilesTxtMdCsvJson'),
  empty: translate('assistant.knowledgeCopyTheFileOrTextIsEmpty'),
  not_found: translate('assistant.knowledgeCopyEntryNotFoundItMayHaveBeen'),
});

function transport(err) {
  if (!err?.response) return translate('assistant.copyCannotConnectToTheServerCheckYour');
  if (err.response.status >= 500) return translate('assistant.copyServerErrorPleaseTryAgain');
  return '';
}

/** Fixed localized feedback for a failed knowledge request. */
export function knowledgeErrorText(err) {
  const code = assistantErrorCode(err);
  if (code === 'invalid') {
    return translate('assistant.knowledgeCopyEntryNotSavedCheckTheFields');
  }
  return ERRORS()[code] || transport(err) || translate('assistant.knowledgeCopyCouldNotCompleteTheActionPleaseTry');
}



export function formatWhen(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? formatDate(d, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';
}

/** A hit's heading: the entry's title or the document with its fragment. */
export function hitTitle(hit) {
  if (hit?.entry) return hit.entry.title || hit.entry.slug || '';
  if (hit?.document) {
    const { title, fragment, fragments } = hit.document;
    return translate('assistant.knowledgeCopyFragmentOf', { value1: title, value2: fragment, value3: fragments });
  }
  return '';
}

export function embeddingsText(embeddings) {
  if (!embeddings?.provider) return translate('assistant.knowledgeCopyOnlyKeywordSearchIsCurrentlyAvailable');
  return translate('assistant.knowledgeCopySemanticAndKeywordSearch');
}
